import { LBButton, LBHelpIcon } from '@linearb/buzz';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';

const unconfiguredTeam = {
  title: (
    <>
      <div className='font-normal'>
        <div className='text-3xl'>One Piece Missing</div>
        <div className='text-lg'>Iterations are almost complete</div>
      </div>
      <div className='mt-2 text-sm'>
        "But it only works if the ACME team is connected to a project management
        provider. No link, no sync.
      </div>
    </>
  ),
  info: (
    <>
      <div className='mt-2 text-lg font-medium'>Complete the puzzle</div>
      <ol className='list-inside list-decimal text-sm font-normal'>
        <li>
          Go to Settings {'>'} Teams Settings {'>'} Project Management.
        </li>
        <li>Define the scope to identify the ACME team.</li>
      </ol>
      <div className='mt-2 text-muted-foreground text-sm font-normal'>
        Note: It may take a few minutes for data to appear after setup.
      </div>
      <div className='mt-6'>
        <LBButton
          onClick={() =>
            LighthouseService.navigateArticle(
              ARTICLE_IDS.SET_JIRA_BOARD_PER_TEAM
            )
          }
        >
          <LBHelpIcon />
          Learn more
        </LBButton>
      </div>
    </>
  ),
  buttons: [],
  afterButtonInfo: ''
};

export default unconfiguredTeam;
